module.exports = __webpack_public_path__ + "img/undraw_notes1_cf55.d9b385b2.svg";